import { render, staticRenderFns } from "./IconDraggable.vue?vue&type=template&id=d630ea92&"
import script from "./IconDraggable.vue?vue&type=script&lang=js&"
export * from "./IconDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d630ea92')) {
      api.createRecord('d630ea92', component.options)
    } else {
      api.reload('d630ea92', component.options)
    }
    module.hot.accept("./IconDraggable.vue?vue&type=template&id=d630ea92&", function () {
      api.rerender('d630ea92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDraggable.vue"
export default component.exports